<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="col-sm-12 list-container nopads pt-2">
    <div class="col-sm-12 d-flex justify-content-end"
    >
      <button class="btn btn-primary my-2" @click.stop="showVideoView()" :disabled="!canPlay">
          <font-awesome-icon icon="play-circle" class="me-2" />{{ $t('observations_videos.play') }}
      </button>
    </div>
    <div class="col-sm-12 list-content result-table">
      <Transition name="fade">
          <vue3-datatable
              v-if="tableItems && tableItems.length > 0"
              :rows="tableItems"
              :columns="fields"
              :pagination="false"
              :sticky-header="true"
              height="70vh"
              :sortable="true"
              skin="bh-table-compact"
              row-class="routa-table-row"
              cell-class="routa-table-cell"
          >
              <template #actions="row">
                  <div class="dropdown">
                      <div
                          class="toolbar-item dropdown ms-2"
                          @mouseenter="openDropdown(row.value.index)"
                          @mouseleave="closeDropdown"
                      >
                          <button class="btn btn-sm btn-outline-dark"> <i class="fa fa-ellipsis-h" style="font-size: .8em; padding: 0; line-height: 1em;"></i></button>
                          <div v-if="activeDropdown === row.value.index" class="dropdown-menu-left-up">
                              <button class="dropdown-item" @click.stop="showVideoMetadata(row.value.index, true)">
                                  {{ $t('observations_videos.front_video') }}
                              </button>
                              <button class="dropdown-item" @click.stop="showVideoMetadata(row.value.index, false)">
                                 {{ $t('observations_videos.rear_video') }}
                              </button>
                          </div>
                      </div>
                  </div>
              </template>
          </vue3-datatable>
      </Transition>
    </div>
  </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {timeUtils} from '../../mixins/TimeUtils'
import Vue3Datatable from '@bhplugin/vue3-datatable'


export default {
    name: 'ObservationVideoList',
    mixins: [restApi, timeUtils],
    components: {Vue3Datatable},
    props: {
        canPlay: Boolean,
        videosMetadata: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data: function () {
        return {
            tableItems: [],
            activeDropdown: null,
            fields: [
                {
                    field: "start_time",
                    title: this.$t('observations_videos.start_time'),
                    sort: false,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "customer",
                    title: this.$t('observations_videos.customer'),
                    sort: false,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "contract",
                    title: this.$t('observations_videos.contract'),
                    sort: false,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "work_order",
                    title: this.$t('observations_videos.order'),
                    sort: false,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "vehicle",
                    title: this.$t('observations_videos.vehicle'),
                    sort: false,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "actions",
                    title: '',
                    sort: false,
                    headerClass: 'routa-table-header'
                }
            ]
        }
    },
    watch: {
        videosMetadata: function (videosMetadata) {
            this.tableItems = []
            const temp = []
            videosMetadata.forEach((metadata,index) => {
                temp.push({
                    id: metadata[0].id,
                    index: index,
                    vehicle: this.getVehicleString(metadata[0].vehicle),
                    work_order: metadata[0].work_order.task_type.name,
                    contract: metadata[0].work_order.contract.name,
                    customer: metadata[0].work_order.contract.customer.name,
                    start_time: this.toLocalTime(metadata[0].start_time)
                })
            })
            this.$nextTick(() => this.tableItems = temp)
        }
    },
    methods: {
        // Toolbar methods
        openDropdown(index) {
            this.activeDropdown = index;
        },
        closeDropdown() {
            this.activeDropdown = null;
        },
        showVideoView: function () {
            this.$emit('showVideoView')
        },
        showVideoMetadata: function (index, isFrontVideo) {
            this.$emit('videoMetadata', this.videosMetadata[index], isFrontVideo)
        },
        getVehicleString: function (vehicle) {
            let result = '-'
            if (vehicle && vehicle.make) {
                result = vehicle.make
                if (vehicle.vehicle_model) {
                    result += ' ' + vehicle.vehicle_model
                }
            }
            return result
        }
    }
}
</script>

<style scoped>

</style>
